import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AdminLayout } from "./admin/AdminLayout";
import { WorkspacesPage } from "./admin/WorkspacesPage";
import { WorkspaceDetailPage } from "./admin/WorkspaceDetailPage";
import { ProvidersPage } from "./admin/ProvidersPage";
import { PlansPage } from "./admin/PlansPage";
import { PlanDetailPage } from "./admin/PlanDetailPage";
import { QueuePage } from "./admin/QueuePage";
import { PortalApp } from "./portal/PortalApp";
import "./styles.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Navigate to="/plans" replace />} />
        {/* The client portal sits outside the admin layout: different audience,
            different chrome, no sidebar. */}
        <Route path="/p/:token" element={<PortalApp />} />
        <Route element={<AdminLayout />}>
          <Route path="/workspaces" element={<WorkspacesPage />} />
          <Route path="/workspaces/:id" element={<WorkspaceDetailPage />} />
          <Route path="/plans" element={<PlansPage />} />
          <Route path="/plans/:id" element={<PlanDetailPage />} />
          <Route path="/queue" element={<QueuePage />} />
          <Route path="/ai" element={<ProvidersPage />} />
        </Route>
        <Route path="*" element={<Navigate to="/plans" replace />} />
      </Routes>
    </BrowserRouter>
  </StrictMode>,
);
